<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    newTitle="Nova Conta a Pagar"
    newCreateButtonLabel="Adicionar Conta a Pagar"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :addButtonIcon="addButtonIcon"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    addButtonIcon:{
      type: String,
      default: "mdi-plus",
    },
    inlineAddButton: {
      type: Boolean,
      default: false,
    },
    modelNameSingular: String,
    extraData2: null,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_CASH_OUTFLOW,
          variables:{
            saleId: this.extraData2?.id ?? null
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.cashOutflow;
          this.extraData = response.data;
          if(this.extraData2){
            this.extraData.extraData2 = this.extraData2;
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(cashOutflow) {
      // console.log("cashOutflow", cashOutflow, cashOutflow.validations, this.deepFilterEntryWithAllowedFieldsForMutation(cashOutflow, cashOutflow.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_CASH_OUTFLOW_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(cashOutflow, cashOutflow.validations)
          }
        })
        .then(response => {
          var errors = response.data.createCashOutflow.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_CASH_OUTFLOW = gql `
  query($saleId: ID){
    accountContext {
      cashOutflow(saleId: $saleId) {
        id
        code
        billDate
        cashFlowId
        totalPrice
        observation
        periodIds
        chartId
        chart {
          id
          text
        }
        supplierId
        supplier {
          id
          name
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsIntervalId
          installmentsInterval {
            id
            description
            intervalInDays
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            totalPaidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
        validations
      }
      allPeople {
        id
        name
      }
      allHarvests {
        id
        name
      }
      allPeriodsEnabledForCostApportionment(periodStatuses: [1]) {
        id
        name
        additionalInfo
        secondAdditionalInfo
      }
    }
    globalContext {
      allPeriodStatuses
    }
  }
`;
 
const CREATE_CASH_OUTFLOW_MUTATION = gql `
  mutation($input: CashOutflowCreateInputObject!) {
    createCashOutflow(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
